import { Box, IconButton, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import Bell from '@/shared/ui/icons/Bell.svg';

import { ROUTES } from '@/shared/constants';

import { TNotificationTypeTheme } from '@/entities/notifications';

import { NotificationsBadge } from './NotificationsBadge';

interface IProps {
  compact?: boolean;
  count: number;
  isLoading: boolean;
  type: TNotificationTypeTheme;
}

/**
 * Компонент для отображения уведомлений
 * @param root0 - пропсы
 * @param root0.type - тип блока(светлый или темный)
 * @param root0.count - количество уведомлений
 * @param root0.isLoading - состояние загрузки уведомлений
 * @param root0.compact - компактный режим (только колокол, без текстовой подписи) для мобильной шапки
 */
export const NotificationsLayout = ({
  type,
  count,
  isLoading,
  compact
}: IProps) => {
  const { palette } = useTheme();
  const navigate = useNavigate();

  const textColor =
    type === 'light' ? palette.common.white : palette.text.primary;
  const iconColor =
    type === 'light' ? palette.common.white : palette.text.primary;

  if (isLoading) {
    return null;
  }

  const bellIcon = (
    <Bell
      style={{
        width: 24,
        height: 24,
        stroke: iconColor
      }}
    />
  );

  return (
    <Box display='flex' alignItems='center' gap={1}>
      {!compact && (
        <Typography variant='h8' color={textColor}>
          Уведомления
        </Typography>
      )}
      <IconButton onClick={() => navigate(ROUTES.notifications)}>
        <NotificationsBadge count={count}>{bellIcon}</NotificationsBadge>
      </IconButton>
    </Box>
  );
};
